<template>
  <div>
    <div class="breadcrumb-area pos-relative w-100">
      <h1>Danh sách vị trí thiết bị</h1>
      <div class="btn-group float-right">
        <DraggableTable
          :naming="$router.name"
          v-model="fieldsTable"
          @change="filterTable = $event"
        />
        <button
          v-if="canCreate()"
          @click="openFormDevice('Thêm thông tin thiết bị')"
          class="f12 font-medium btn btn-outline-secondary"
        >
          Thêm thông tin thiết bị
        </button>
      </div>
    </div>
    <div class="card p-10 pt-15 b-t-1-869fb229">
      <div class="card-header m-b-10">
        <form class="box-search" @submit.prevent="submitForm">
          <div class="form-group">
            <input
              type="text"
              v-model.trim="search.serial"
              class="form-control f12 hc-37 text-search"
              placeholder="Serial thiết bị"
            />
          </div>
          <div class="form-group">
            <Select2
              v-model="search.deviceType"
              :options="deviceTypeOptions"
              placeholder="Loại thiết bị"
            />
          </div>
          <div class="form-group">
            <Select2
              v-model="search.typeAppendix"
              :options="typeAppendixOptions"
              placeholder="Loại PL/BB"
            />
          </div>
          <div class="form-group">
            <input type="hidden" class="form-control text-left" v-model="merchantSelected" />
            <input
              type="text"
              class="form-control text-left"
              :value="merchantSelected.merchantName ? `${merchantSelected.merchantName}` : ''"
              placeholder="Merchant"
              v-b-modal.select-merchant-dialog
            />
          </div>
          <div class="form-group" v-if="search.customerId">
            <Select2 v-model="search.locId" :options="locIdOptions" placeholder="ĐCNTT" />
          </div>
          <div class="form-group">
            <Select2 v-model="search.verify" :options="verifyOptions" placeholder="TT xác thực" />
          </div>
          <div class="form-group">
            <Select2
              v-model="search.activeSaleId"
              :options="saleOptions"
              placeholder="Sale phụ trách"
            />
          </div>
          <div class="form-group">
            <Select2
              v-model="search.managerSaleId"
              :options="managerOptions"
              placeholder="Quản lý"
            />
          </div>
          <div class="form-group">
            <Select2
              v-model="search.status"
              :options="Config.getSearch(statusOptions)"
              placeholder="Trạng thái"
            />
          </div>
          <div class="form-group form-group-action">
            <button type="button" class="btn btn-primary hc-37 mr-2 pt-2" @click="submitForm">
              <i class="bx bx-filter-alt"></i><span>&nbsp;</span>Lọc
            </button>
            <button type="button" class="btn btn-outline-light hc-37 mr-2 pt-2" @click="removeForm">
              <i class="bx bx-filter-alt"></i><span>&nbsp;</span>Bỏ lọc
            </button>
          </div>
        </form>
      </div>
      <div class="card-body">
        <div class="tab-content" id="nav-tabContent">
          <div class="p-10">
            Tổng: <strong class="text-primary">{{ pagination.total }}</strong>
            <b-table
              :busy.sync="tbLoading"
              sticky-header
              responsive
              hover
              :items="lists"
              :fields="filterTable"
              :fixed="true"
              :bordered="true"
            >
              <template #table-busy>
                <div class="text-center my-2">
                  <b-spinner class="align-middle"></b-spinner>
                </div>
              </template>
              <template #cell(index)="{ index }">
                {{ getIndex(index) }}
              </template>
              <template #cell(device)="{ item }">
                <p>Serial: {{ item.serial }}</p>
                <p>
                  Loại TB:
                  {{ item.deviceType | transformData(deviceTypeOptions) }}
                </p>
                <p>
                  Loại PL/BB:
                  {{ item.typeAppendix | transformData(typeAppendixOptions) }}
                </p>
              </template>
              <template #cell(mc)="{ item }">
                <p>Tên: {{ item.merchantName }}</p>
                <p>Email: {{ item.email }}</p>
                <p>SĐT: {{ item.mobile }}</p>
                <p>Địa chỉ: {{ item.address }}</p>
                <p>
                  Sale phụ trách: {{ item.activeSaleName }} -
                  {{ item.activeSaleEmail }}
                </p>
              </template>
              <template #cell(dcntt)="{ item }">
                <p>Tên: {{ item.areaName }}</p>
                <p>Địa chỉ: {{ item.areaAddress }}</p>
                <p>Quận/Huyện: {{ item.areaDistrict }}</p>
                <p>Tỉnh/Thành phố: {{ item.areaCity }}</p>
              </template>
              <template #cell(verification)="{ item }">
                <p>
                  Tình trạng:
                  <Status :value="item.verify" :config="verifyOptions" />
                </p>
                <p>
                  Thời gian:
                  {{ item.verifyDate ? new Date(item.verifyDate).toLocaleString() : 'N/A' }}
                </p>
                <p>Người xác thực: {{ item.verifyByEmail || 'N/A' }}</p>
              </template>
              <template #cell(dates)="{ item }">
                <p>Tạo: {{ new Date(item.createAt).toLocaleString() }}</p>
                <p>
                  Cập nhật cuối:
                  {{ new Date(item.modifiedAt).toLocaleString() }}
                </p>
              </template>
              <template #cell(status)="{ item }">
                <Status :value="item.status" :config="statusOptions" />
              </template>
              <template #cell(action)="{ item }">
                <b-dropdown class="text-center" variant="outline-light">
                  <b-dropdown-item @click="detail(item.dataId)" class="dropdown-item"
                    ><span>&nbsp;</span>Chi tiết
                  </b-dropdown-item>
                  <b-dropdown-item
                    v-if="canUpdate()"
                    @click="
                      openFormDevice('Sửa thông tin thiết bị', {
                        item,
                        type: 'device',
                        isEdit: true,
                      })
                    "
                    class="dropdown-item"
                    ><span>&nbsp;</span>Sửa thông tin thiết bị
                  </b-dropdown-item>
                  <b-dropdown-item
                    v-if="canUpdate()"
                    @click="
                      openFormDevice('Sửa thông tin MC', {
                        item,
                        type: 'mc',
                        isEdit: true,
                      })
                    "
                    class="dropdown-item"
                    ><span>&nbsp;</span>Sửa thông tin MC
                  </b-dropdown-item>
                  <b-dropdown-item
                    v-if="canUpdate()"
                    @click="
                      openFormDevice('Sửa thông tin DCNTT', {
                        item,
                        type: 'area',
                        isEdit: true,
                      })
                    "
                    class="dropdown-item"
                    ><span>&nbsp;</span>Sửa thông tin DCNTT
                  </b-dropdown-item>
                  <b-dropdown-item
                    v-if="canLock(item)"
                    @click="lock(item, true)"
                    class="dropdown-item"
                    ><span>&nbsp;</span>Khoá
                  </b-dropdown-item>
                  <b-dropdown-item
                    v-if="canUnLock(item)"
                    @click="lock(item, false)"
                    class="dropdown-item"
                    ><span>&nbsp;</span>Mở khoá
                  </b-dropdown-item>
                  <b-dropdown-item
                    v-if="canVerify(item)"
                    @click="verify(item, true)"
                    class="dropdown-item"
                    ><span>&nbsp;</span>Xác thực
                  </b-dropdown-item>
                  <b-dropdown-item
                    v-if="canUnVerify(item)"
                    @click="verify(item, false)"
                    class="dropdown-item"
                    ><span>&nbsp;</span>Bỏ xác thực
                  </b-dropdown-item>
                </b-dropdown>
              </template>
            </b-table>
          </div>
        </div>
        <div class="pagination-bottom">
          <b-pagination
            v-model="search.page"
            :total-rows="pagination.total"
            :per-page="search.limit"
            class="fl-right mr-2"
          ></b-pagination>
        </div>
      </div>
    </div>
    <SelectMerchant @selectMerchant="onSelectMerchant" />
    <VueLoadingOverlay :active.sync="showLoading" :is-full-page="true"> </VueLoadingOverlay>
  </div>
</template>

<script>
  import SelectMerchant from '@/components/SelectMerchant.vue'
  import mxItemAction from './mx-item-action.js'
  import Config from '@/thirdParty/config'
  import { MerchantService } from '@/services/merchant.service'
  import cloneDeep from 'lodash/cloneDeep'
  const fieldsTable = [
    { key: 'index', label: 'STT', class: 'text-center' },
    { key: 'device', label: 'Thiết bị', thStyle: 'min-width: 170px' },
    { key: 'mc', label: 'MC', thStyle: 'min-width: 170px' },
    { key: 'dcntt', label: 'ĐCNTT', thStyle: 'min-width: 170px' },
    { key: 'verification', label: 'TT xác thực', thStyle: 'min-width: 190px' },
    { key: 'dates', label: 'Ngày', thStyle: 'min-width: 190px' },
    { key: 'status', label: 'Trạng thái' },
    { key: 'action', label: 'Hành động', fixIndex: 999, class: 'text-center' },
  ]
  export default {
    name: 'Device-Location',
    data() {
      return {
        Config,
        fieldsTable,
        filterTable: fieldsTable,
        lists: [],
        showLoading: false,
        tbLoading: false,
        search: {
          limit: 20,
          page: 1,
        },
        pagination: {
          total: 0,
        },
        merchantSelected: {},
      }
    },
    components: { SelectMerchant },
    mixins: [mxItemAction],
    watch: {
      'search.page': function () {
        this.fetchData()
      },
    },
    created() {
      this.fetchData()
    },
    methods: {
      onSelectMerchant(mc) {
        this.search.customerId = mc.customerId
        this.merchantSelected = mc
        this.getLocIdOptions()
      },
      preareData() {
        const data = cloneDeep(this.search)
        for (const key in data) {
          if (data[key] === '0') delete data[key]
        }
        return data
      },
      async fetchData() {
        try {
          this.tbLoading = true
          const params = this.preareData()
          const response = await MerchantService.listDeviceLocation(params)
          if (response.code === 1000) {
            this.lists = response.data
            this.pagination.total = response.meta.pagination.total
          } else {
            this.showFailMx(response.message)
          }
        } catch (error) {
          console.log(error)
        } finally {
          this.tbLoading = false
        }
      },
      async removeForm() {
        this.search = {
          limit: 20,
          page: 1,
        }
        this.merchantSelected = {}
        await this.fetchData()
      },
      async submitForm() {
        this.search.page = 1
        this.fetchData()
      },
    },
  }
</script>
<style scoped></style>
